import { captureException } from '@sentry/react';

export interface LocalStorageContextInterface {
  captureException: typeof captureException;
}

export const localStorageContext: LocalStorageContextInterface = {
  captureException,
};
